import Grid from "@mui/material/Grid";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { AdditionalMetrics } from "components/GraphsSections/AdditionalMetrics";
import { GeneralOverview } from "components/GraphsSections/GeneralOverview";
import { MembersByTiers } from "components/GraphsSections/MembersByTiers";
import { UnitsWalletOverview } from "components/GraphsSections/UnitsWalletOverview";
import { TopHeader } from "components/Header/TopHeader/TopHeader";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    header: {
      display: "inline-block",
      fontSize: 18,
      paddingBottom: theme.spacing(5),
    },
    gridContainer: {
      marginBottom: theme.spacing(12),
    },
    gridChild: {
      display: "flex",
      flexDirection: "column",
    },
  }),
);

export function Dashboard() {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <>
      <TopHeader title={message({ id: "dashboard" })} />
      <Grid container className={classes.gridContainer} mt={8}>
        <Grid className={classes.gridChild} item xs={12}>
          <GeneralOverview />
        </Grid>
      </Grid>
      <Grid container className={classes.gridContainer}>
        <Grid className={classes.gridChild} item xs={12}>
          <UnitsWalletOverview />
        </Grid>
      </Grid>
      <Grid container className={classes.gridContainer} spacing={10}>
        <Grid className={classes.gridChild} item xs={9}>
          <span className={classes.header}>
            {message({ id: "additionalMetrics" })}
          </span>
          <AdditionalMetrics />
        </Grid>
        <Grid className={classes.gridChild} item xs={3}>
          <span className={classes.header}>
            {message({ id: "membersByTiers" })}
          </span>
          <MembersByTiers />
        </Grid>
      </Grid>
    </>
  );
}
